"use client"

import { EqualApproximately } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `EqualApproximatelyIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const EqualApproximatelyIcon = component(Icon)({
  as: EqualApproximately,
})
